const state = {
  wholesale: [
    {
      product: "",
      data: [
        {
          unity: "",
          price: "",
          scratched: 0,
        },
        {
          unity: "",
          price: "",
          scratched: 0,
        },
        {
          unity: "",
          price: "",
          scratched: 0,
        },
      ],
    },
  ],
};

const getters = {
  getWholesale(state) {
    return state.wholesale;
  },
};

const mutations = {
  SET_WHOLESALE(state, payload) {
    state.wholesale.push(payload);
  },
  SET_REMOVE_WHOLESALE(state, payload) {
    state.wholesale.splice(payload, 1);
  },
};

const actions = {
  setWholesale({ commit }, payload) {
    commit("SET_WHOLESALE", payload);
  },
  setRemoveWholesale({ commit }, payload) {
    commit("SET_REMOVE_WHOLESALE", payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
